import type { BoxProps } from '@mui/material';
import { Box } from '@mui/material';

type FlexboxProps = {
  children: React.ReactNode;
} & BoxProps;

export const Flexbox = ({ children, ...props }: FlexboxProps) => (
  <Box
    display="flex"
    justifyContent="space-between"
    alignItems="center"
    width="100%"
    {...props}
  >
    {children}
  </Box>
);
